import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { City } from '../models/city';

@Injectable()
export class CityService {
   public url: string;
   public controller: string;
   constructor(
      private _http: HttpClient
   ) {
      this.url = environment.urlApi;
      this.controller = 'cities/'
   }

   get(): Observable<any> {
      const json = this._http.get(this.url + this.controller);
      return json;
   }

   getById(id) {
      const json = this._http.get(this.url + this.controller + id);
      return json;
   }

   getCotizaciontById(id) : Observable<any> {
      const json = this._http.get(this.url + "Cotizacion/" + id);
      return json;
   }

   getCotizacion() : Observable<any> {
      const json = this._http.get(this.url + "Cotizacion/");
      return json;
   }


   getByName(name): Observable<any> {
      const json = this._http.get(this.url + this.controller + 'getcitiesbyname/' + name);
      return json;
   }
   getByDepartmentId(departmentid, active): Observable<any> {
      const json = this._http.get(this.url + this.controller + 'getcitiesbydepartmentidincludeinactives/' + departmentid + '/' + active);
      return json;
   }
   getByProvinciaDeparmentId(provinciaid, active): Observable<any> {
      const json = this._http.get(this.url + this.controller + 'getcitiesbyprovinciaiddeparmentincludeinactives/' + provinciaid + '/' + active);
      return json;
   }
   getByDepartmentIdS(departmentid, active): Observable<any> {
      const json = this._http.get(this.url + this.controller + 'getcitiesbydepartmentidincludese/' + departmentid + '/' + active);
      return json;
   }
   create(entity: City) {
      let json = JSON.stringify(entity);
      let params = json;
      let headers = new HttpHeaders().set('content-Type', 'application/json');
      return this._http.post(this.url + this.controller, params, { headers: headers });
   }
   update(id, entity: City) {
      let json = JSON.stringify(entity);
      let params = json;
      let headers = new HttpHeaders().set('content-Type', 'application/json');
      return this._http.put(this.url + this.controller, params, { headers: headers });
   }
   delete() { }
}